export const languages = [
  { language: "French", level: "C2", description: "Native" },
  { language: "English", level: "C2", description: "Native-like proficiency" },
  { language: "German", level: "A2", description: "Elementary · actively improving" },
] as const;
